import BirthPlaceBlock from './birth-place-block';

export * from './birth-place-block';
export default BirthPlaceBlock;
